/* === Custom subscription frequency dropdown — alle Solvey PDPs ===
   Vervangt de visuele rendering van de Firmhouse <select.frequency-select>
   door een custom listbox. Native blijft in DOM zodat form-submit en de
   Firmhouse subscription-app blijven werken.
   Body-class guard verwijderd op 2026-05-08 — de JS wordt via theme.liquid
   al alleen geladen op de 7 Solvey PDPs (zie solvey_pdp_handles). De extra
   restore-probiotics-only check binnenin maakte de trigger NIET op andere
   PDPs zichtbaar → native select bleef staan → palet-tint scheen door. */
(function () {
  var ATTACHED = 'solveyFqAttached';

  // Walk up; warn + neutralize any ancestor that clips the panel.
  // Alleen op mobile uitgevoerd: anders gaan we niet lopen modden in styles
  // die op desktop niet relevant zijn.
  function auditOverflow(sel) {
    var el = sel.parentElement;
    while (el && el !== document.body) {
      var cs = getComputedStyle(el);
      if (cs.overflow === 'hidden' || cs.overflowY === 'hidden' || cs.overflowX === 'hidden') {
        if (window.console && console.warn) {
          console.warn('[solvey-fq] overflow:hidden ancestor neutralised on mobile:', el);
        }
        el.style.setProperty('overflow', 'visible', 'important');
      }
      el = el.parentElement;
    }
  }

  function attach() {
    var selects = document.querySelectorAll('select.frequency-select');
    for (var s = 0; s < selects.length; s++) {
      var sel = selects[s];
      if (sel.dataset[ATTACHED]) continue;
      sel.dataset[ATTACHED] = '1';

      var wrapper = sel.parentElement;
      if (!wrapper) continue;

      if (window.matchMedia('(max-width: 749px)').matches) {
        auditOverflow(sel);
      }

      // Trigger
      var trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'solvey-fq-trigger';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-label', 'Bezorgfrequentie');

      var labelSpan = document.createElement('span');
      labelSpan.className = 'solvey-fq-trigger-label';
      labelSpan.textContent = sel.options[sel.selectedIndex].text;
      trigger.appendChild(labelSpan);

      // Panel
      var panel = document.createElement('ul');
      panel.className = 'solvey-fq-panel';
      panel.setAttribute('role', 'listbox');
      panel.hidden = true;

      var items = [];
      (function buildOptions() {
        for (var i = 0; i < sel.options.length; i++) {
          (function (idx) {
            var opt = sel.options[idx];
            var li = document.createElement('li');
            li.setAttribute('role', 'option');
            li.setAttribute('tabindex', '-1');
            li.dataset.value = opt.value;
            li.textContent = opt.text;
            if (idx === sel.selectedIndex) li.setAttribute('aria-selected', 'true');
            li.addEventListener('click', function () { choose(idx); });
            li.addEventListener('keydown', function (e) {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                choose(idx);
              } else if (e.key === 'ArrowDown') {
                e.preventDefault();
                items[Math.min(idx + 1, items.length - 1)].focus();
              } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                items[Math.max(idx - 1, 0)].focus();
              } else if (e.key === 'Escape') {
                close();
                trigger.focus();
              }
            });
            panel.appendChild(li);
            items.push(li);
          })(i);
        }
      })();

      function choose(i) {
        sel.selectedIndex = i;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        labelSpan.textContent = sel.options[i].text;
        for (var j = 0; j < items.length; j++) {
          if (j === i) items[j].setAttribute('aria-selected', 'true');
          else items[j].removeAttribute('aria-selected');
        }
        close();
        trigger.focus();
      }

      function open() {
        panel.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        var i = sel.selectedIndex;
        if (items[i]) {
          items[i].setAttribute('tabindex', '0');
          setTimeout(function () { items[i] && items[i].focus(); }, 0);
        }
      }

      function close() {
        panel.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        for (var k = 0; k < items.length; k++) items[k].setAttribute('tabindex', '-1');
      }

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (panel.hidden) open();
        else close();
      });
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          open();
        }
      });

      // Bound aan wrapper-instance zodat closures niet lekken bij re-render
      (function (w) {
        document.addEventListener('click', function (e) {
          if (!w.contains(e.target)) close();
        });
      })(wrapper);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close();
      });

      // Plaats trigger op de positie van de select (vóór .nextSibling), niet
      // achter het 15%-badge. Panel komt direct na de trigger.
      wrapper.insertBefore(trigger, sel.nextSibling);
      wrapper.insertBefore(panel, trigger.nextSibling);

      // Activeer de hiding-CSS pas nu de trigger bestaat — voorkomt leeg gat
      // tijdens defer-window of bij JS-fail.
      wrapper.classList.add('solvey-fq-active');

      // Sync wanneer Firmhouse-app de select extern wijzigt
      sel.addEventListener('change', function () {
        var i = sel.selectedIndex;
        labelSpan.textContent = sel.options[i].text;
        for (var k = 0; k < items.length; k++) {
          if (k === i) items[k].setAttribute('aria-selected', 'true');
          else items[k].removeAttribute('aria-selected');
        }
      });

      // Re-sync alle custom dropdown teksten vanuit de native <option>s.
      // Reden: Weglot vertaalt initieel de native options, maar de custom
      // labelSpan + li-items waren al gebuild met de oude tekst. Bij taal-
      // wissel walkt Weglot opnieuw door de DOM en zou ook onze custom
      // elementen moeten vertalen — maar dat is timing-afhankelijk en kan
      // missen op hidden panels of binnen custom elements. Defensief:
      // observe de native select op characterData/childList mutaties en
      // mirror de option-tekst naar ons custom DOM.
      var resyncing = false;
      function resyncFromNative() {
        if (resyncing) return;
        resyncing = true;
        try {
          var idx = sel.selectedIndex;
          if (idx >= 0 && sel.options[idx]) {
            labelSpan.textContent = sel.options[idx].text;
          }
          for (var k = 0; k < items.length && k < sel.options.length; k++) {
            var newText = sel.options[k].text;
            if (items[k].textContent !== newText) items[k].textContent = newText;
          }
        } finally {
          resyncing = false;
        }
      }
      var textObserver = new MutationObserver(function () { resyncFromNative(); });
      textObserver.observe(sel, { childList: true, subtree: true, characterData: true });

      // Hook Weglot language change als beschikbaar — extra zekerheid naast
      // de MutationObserver, want Weglot vertaalt na een korte delay.
      function hookWeglot() {
        if (window.Weglot && typeof window.Weglot.on === 'function') {
          window.Weglot.on('languageChanged', function () {
            // Wacht tot Weglot zijn DOM-pass heeft afgerond
            setTimeout(resyncFromNative, 300);
            setTimeout(resyncFromNative, 1000);
          });
          return true;
        }
        return false;
      }
      if (!hookWeglot()) {
        // Poll voor Weglot-init, max ~5s
        var tries = 0;
        var pollWg = setInterval(function () {
          tries++;
          if (hookWeglot() || tries > 25) clearInterval(pollWg);
        }, 200);
      }
    }
  }

  function init() {
    attach();
    // Idempotent: re-attach als Firmhouse de subscription-block re-rendert
    var observer = new MutationObserver(function () {
      clearTimeout(window.__solveyFqDebounce);
      window.__solveyFqDebounce = setTimeout(attach, 50);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
